@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.package-columns {
  display: flex;
}

.package-details-column {
  padding: 15px;
  width: 50%;
  border-right: 1px solid @multi-package-list--package-details--border-color;

  &:last-child {
    border: none;
  }
}

.package-header {
  background-color: @multi-package-list--package-header--background-color;
  padding: 10px 15px;
  box-shadow: 0 1px 3px @multi-package-list--package-header--box-shadow-color;
}
